<template>
  <div class="initials-avatar">
    <b-avatar class="user-select-none"
              :text="text"
              :variant="variant"
              :title="title"
              v-bind="$attrs" />
  </div>
</template>

<script>
  import { BAvatar } from 'bootstrap-vue'

  const variants = [
    'light-primary', 'light-secondary', 'light-success', 'light-danger', 'light-warning', 'light-info',
    'light-pink', 'light-orange', 'light-teal', 'light-indigo', 'light-lime',
    'light-purple', 'light-cyan', 'light-emerald', 'light-rose', 'light-amber', 'light-mint',
  ]

  export default {
    name: 'InitialsAvatar',
    components: {
      BAvatar,
    },
    inheritAttrs: false,
    props: {
      familyName: {
        type: String,
        required: true,
        default: '',
      },
      givenName: {
        type: String,
        required: true,
        default: '',
      },
      showTitle: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      name() {
        return `${this.familyName.toLowerCase()}${this.givenName.toLowerCase()}`
      },
      text() {
        return `${this.familyName.charAt(0).toUpperCase()}${this.givenName.charAt(0).toUpperCase()}`
      },
      title() {
        return this.showTitle ? `${this.familyName} ${this.givenName}` : null
      },
      variant() {
        let hash = 0
        for (let i = 0; i < this.name.length; i += 1) {
          hash = ((hash << 5) - hash) + this.name.charCodeAt(i) // eslint-disable-line
          hash &= hash // eslint-disable-line
        }
        return variants[Math.abs(hash) % variants.length]
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '~@core/scss/base/bootstrap-extended/include';
  @import '~@core/scss/base/components/variables-dark';

  .initials-avatar {
    background: #fff;
    border-radius: 50% !important;
  }

  .b-avatar {
    &.badge-light-purple {
      background-color: rgba(156, 39, 176, 0.12) !important;
      color: #9c27b0 !important;
    }

    &.badge-light-pink {
      background-color: rgba(233, 30, 99, 0.12) !important;
      color: #e91e63 !important;
    }

    &.badge-light-orange {
      background-color: rgba(255, 152, 0, 0.12) !important;
      color: #ff9800 !important;
    }

    &.badge-light-teal {
      background-color: rgba(0, 150, 136, 0.12) !important;
      color: #009688 !important;
    }

    &.badge-light-indigo {
      background-color: rgba(63, 81, 181, 0.12) !important;
      color: #3f51b5 !important;
    }

    &.badge-light-lime {
      background-color: rgba(205, 220, 57, 0.12) !important;
      color: #cddc39 !important;
    }

    &.badge-light-cyan {
      background-color: rgba(0, 188, 212, 0.12) !important;
      color: #00bcd4 !important;
    }

    &.badge-light-emerald {
      background-color: rgba(46, 125, 50, 0.12) !important;
      color: #2e7d32 !important;
    }

    &.badge-light-rose {
      background-color: rgba(244, 67, 54, 0.12) !important;
      color: #f44336 !important;
    }

    &.badge-light-amber {
      background-color: rgba(255, 193, 7, 0.12) !important;
      color: #ffc107 !important;
    }

    &.badge-light-mint {
      background-color: rgba(0, 121, 107, 0.12) !important;
      color: #00796b !important;
    }
  }

  .dark-layout {

    .initials-avatar {
      background: $theme-dark-body-bg;

      .b-avatar .b-avatar-text span {
        color: inherit !important;
      }
    }
  }
</style>
